import "./Roadmap.scss";

import ButtonOutline from "../../components/shared/ButtonOutline";

import RoadmapIcon from "../../assets/images/roadmap-icon.svg";
import { ArrowRight } from "iconsax-react";
import RoadmapBg from "../../assets/images/roadmap-bg.svg";

export default function Roadmap() {
	return (
		<div className="roadmap" id="roadmap">
			<div className="roadmap-content-wrapper content-wrapper-lg">
				<img className="decoration roadmap-bg" src={RoadmapBg} alt="Roadmap Background" />
				<div className="decoration light light-1" />
				<div className="decoration light light-2" />

				<h3 className="roadmap-title" data-aos="zoom-in">
					Roadmap
				</h3>
				<div className="roadmap-desc" data-aos="fade-up" data-aos-delay="50">
					Pioneering the future with intelligent,secure, and scalable
					Al agents and solutions that ignite innovation and
					accelerate transformation.
				</div>

				<div className="roadmap-cards-wrapper">
					<ul className="roadmap-cards">
						<li className="roadmap-card-item" data-aos="zoom-out-up" data-aos-delay="100">
							<div className="roadmap-card" id="roadmap-card-1">
								<div className="roadmap-card-number">1</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Beta Launch & Refinement
								</div>
								<div className="roadmap-card-desc">
									In the second quarter, we will release the
									beta version for limited user testing,
									gather feedback to refine platform features,
									run a marketing campaign to boost awareness
									and participation, and launch incentive
									programs to encourage community engagement.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li className="roadmap-card-item" data-aos="zoom-out-right" data-aos-delay="300" data-aos-offset="0" data-aos-anchor="#roadmap-card-1">
							<div className="roadmap-card">
								<div className="roadmap-card-number">2</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Beta Launch & Refinement
								</div>
								<div className="roadmap-card-desc">
									In the second quarter, we will release the
									beta version for limited user testing,
									gather feedback to refine platform features,
									run a marketing campaign to boost awareness
									and participation, and launch incentive
									programs to encourage community engagement.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li className="roadmap-card-item" data-aos="zoom-out-up" data-aos-delay="500" data-aos-offset="0" data-aos-anchor="#roadmap-card-1">
							<div className="roadmap-card">
								<div className="roadmap-card-number">3</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Beta Launch & Refinement
								</div>
								<div className="roadmap-card-desc">
									In the second quarter, we will release the
									beta version for limited user testing,
									gather feedback to refine platform features,
									run a marketing campaign to boost awareness
									and participation, and launch incentive
									programs to encourage community engagement.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li className="roadmap-card-item" data-aos="zoom-out-left" data-aos-delay="700" data-aos-offset="0" data-aos-anchor="#roadmap-card-1">
							<div className="roadmap-card">
								<div className="roadmap-card-number">4</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Beta Launch & Refinement
								</div>
								<div className="roadmap-card-desc">
									In the second quarter, we will release the
									beta version for limited user testing,
									gather feedback to refine platform features,
									run a marketing campaign to boost awareness
									and participation, and launch incentive
									programs to encourage community engagement.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
